import React, {Fragment, useEffect, useState} from "react";
import {compose} from "redux";
import {connect} from "react-redux";
import {translate} from "react-i18next";
import {Alert, Button, Col, Form, Modal, Row, Steps} from "antd";
import {GUTTER_MD, GUTTER_SM} from "../../../../styles/constants";
import EnhancedModal from "../../../../components/enhanced-modal";
import FirstStep from "./components/FirstStep";
import SecondStep from "./components/SecondStep";
import {sqlDoesNotContainBlacklistedKeywords, sqlIsValid} from "./components/utils";
import {CREATE_MODE} from "../utils";

const mapStateToProps = (state) => ({
    connId: state.scenes.mappingHandler.datasetBuilder.index.connId,
    query: state.scenes.mappingHandler.datasetBuilder.unionModalProps.query,
    updateInDbData: state.scenes.mappingHandler.datasetBuilder.unionModalProps.updateInDbData,
    datasets: state.scenes.mappingHandler.datasetBuilder.index.datasets,
    isSuccess: state.scenes.mappingHandler.datasetBuilder.index.isSuccess,
    dsPrefix: state.config.dataManagement.datasetPrefix,
    blackListQueryWord: state.config.dataManagement.blackListQueryWord,
});

const mapPropsToFields = ({modalInfo, connId, query, selectedTables}) => {
    const {dataset} = modalInfo;
    return {
        id: Form.createFormField({value: dataset && dataset.id ? dataset.id : 0}),
        connection_Id: Form.createFormField({value: dataset && dataset.connection_Id ? dataset.connection_Id : connId}),
        query: Form.createFormField({value: dataset && dataset.query ? dataset.query : query}),
        selectedTables: Form.createFormField({value: dataset && dataset.selectedTables ? dataset.selectedTables : selectedTables}),
        name: Form.createFormField({value: dataset && dataset.name ? dataset.name : ""}),
        description: Form.createFormField({value: dataset && dataset.description ? dataset.description : ""}),
        columns: Form.createFormField({value: dataset && dataset.columns ? dataset.columns : ""}),
    }
};

const isDatasetValid = (dataset, dsPrefix) => {
    return !!dataset.name && !!dataset.query && !dataset.name.substring(0, dsPrefix.length).toLowerCase().includes(dsPrefix.toLowerCase())
}

const checkAndUpdateDataset = (dataset, modalInfo, t, query, connectionId, updateInDbData, allDatasets, dsPrefix) => {
    if (modalInfo.mode === CREATE_MODE && allDatasets.map(d => d.name).includes(dataset.name)) {
        Modal.warning({
            title: t('commons.alerts.invalidForm.title'),
            content: t('scenes.mappingHandler.DatasetBuilder.wizard.step.second.datasetNameAlreadyExists')
        });
        return false;
    }
    if (isDatasetValid(dataset, dsPrefix)) {
        modalInfo.action(dataset, query, connectionId, updateInDbData);
        return true;
    }
    Modal.warning({
        title: t('commons.alerts.invalidForm.title'),
        content: t('commons.alerts.invalidForm.content')
    });
    return false;
}

const CreateModifyDatasetModal = ({
                                      isModalVisible,
                                      onModalHide,
                                      modalInfo,
                                      t,
                                      form,
                                      query,
                                      connId,
                                      updateInDbData,
                                      disableModify,
                                      isDataflowBuilder,
                                      datasets,
                                      isSuccess,
                                      dsPrefix,
                                      blackListQueryWord
                                  }) => {
    const [step, setStep] = useState(1);
    useEffect(() => {
        if (isSuccess) {
            setStep(1);
            onModalHide();
        }
    }, [isSuccess]);
    return (
        <EnhancedModal
            visible={isModalVisible}
            onCancel={() => {
                setStep(1);
                onModalHide();
            }}
            fullscreen
            title={modalInfo ? t(`components.datasetList.modals.${modalInfo.mode}.title`, {
                datasetName: modalInfo.dataset ? modalInfo.dataset.name : ""
            }) : ""}
            footer={<Row type="flex" justify="end" align="middle" gutter={GUTTER_SM}>
                <Col>
                    <Button
                        onClick={() => {
                            setStep(1);
                            onModalHide();
                        }}>{t('commons.buttons.close.title')}
                    </Button>
                </Col>
                {step === 1 && (<Col>
                    <Button
                        type="primary"
                        disabled={!query || !connId}
                        onClick={async () => {
                            if (!sqlDoesNotContainBlacklistedKeywords(query, blackListQueryWord.split("|"), t)) return;
                            if (!sqlIsValid(query, t)) return;
                            setStep(2);
                        }}
                    >
                        {t('commons.buttons.next.title')}
                    </Button>
                </Col>)}
                {step === 2 && (<Fragment>
                    <Col>
                        <Button
                            type="default"
                            onClick={() => setStep(1)}
                        >
                            {t('commons.buttons.goBack.title')}
                        </Button>
                    </Col><Col>
                    <Button
                        type="primary"
                        onClick={() => {
                            const formValues = {};
                            // Dovrebbe bastare form.getFieldsValue() ma al momento di cliccare su save non ha i valori...
                            ["id", "name", "description", "connection_Id", "query"].forEach(field => formValues[field] = form.getFieldValue(field));
                            checkAndUpdateDataset(formValues, modalInfo, t, query, connId, updateInDbData || form.getFieldValue("columns") || [], datasets, dsPrefix);
                        }}
                        disabled={disableModify}
                    >
                        {t('commons.buttons.save.title')}
                    </Button>
                </Col>
                </Fragment>)}
            </Row>}
        >
            {isDataflowBuilder && (<Alert
                type="warning"
                showIcon
                message={t('scenes.mappingHandler.DatasetBuilder.wizard.isDataflowBuilder.message')}
            />)}
            <Steps current={step} size="small" style={{marginBottom: GUTTER_MD}}>
                <Steps.Step
                    title={
                        <span>
                            {t('components.datasetList.modals.steps.first.title')}
                        </span>
                    }
                    icon={
                        <Button
                            shape="circle"
                            type={step === 1 ? 'primary' : null}
                            size="small"
                        >
                            1
                        </Button>
                    }
                />
                <Steps.Step
                    title={
                        <span>
                            {t('components.datasetList.modals.steps.second.title')}
                        </span>
                    }
                    icon={
                        <Button
                            shape="circle"
                            type={step === 2 ? 'primary' : null}
                            size="small"
                        >
                            2
                        </Button>
                    }
                />
            </Steps>
            {step === 1 && <FirstStep form={form} modalInfo={modalInfo} disableModify={disableModify}
                                      isDataflowBuilder={isDataflowBuilder}/>}
            {step === 2 &&
                <SecondStep form={form} disableModify={disableModify} isDataflowBuilder={isDataflowBuilder}/>}
        </EnhancedModal>
    )
}

export default compose(
    translate(),
    connect(mapStateToProps),
    Form.create({mapPropsToFields})
)(CreateModifyDatasetModal);
